/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ADVANCED_FORMS_CAPABILITY_STRINGS,
  CONTENT_CAPABILITY_STRINGS,
  DATA_SERVICES_CAPABILITY_STRINGS,
  INTEGRATIONS_CAPABILITY_STRINGS,
  SEARCH_CAPABILITY_STRINGS,
} from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityStrings.constants';
import { DxpCapability } from 'apps/console-core/src/Constants/DxpCapabilities/defs/DxpCapability.defs';
import { getOrganisationPath } from 'apps/console-core/src/Utilities/GetOrganisationPath/GetOrganisationPath';
import {
  DXP_MENU_ADVANCED_FORMS_SECTION,
  DXP_MENU_CONTENT_MANAGEMENT_SECTION,
  DXP_MENU_DATA_SERVICES_SECTION,
  DXP_MENU_INTEGRATIONS_SECTION,
  DXP_MENU_SEARCH_SECTION,
} from './NavSections.constants';

/**
 * Advanced forms.
 */
export const ADVANCED_FORMS: DxpCapability = {
  key: `advanced-forms`,
  menuSections: [DXP_MENU_ADVANCED_FORMS_SECTION],
  path: getOrganisationPath(`/advanced-forms`),
  prefix: `advanced-forms`,
  title: ADVANCED_FORMS_CAPABILITY_STRINGS.title,
};

/**
 * Content management.
 */
export const CONTENT_MANAGEMENT: DxpCapability = {
  key: `content-management`,
  menuSections: [DXP_MENU_CONTENT_MANAGEMENT_SECTION],
  path: getOrganisationPath(`/content-management`),
  prefix: `content-management`,
  title: CONTENT_CAPABILITY_STRINGS.title,
};

/**
 * Data services.
 */
export const DATA_SERVICES: DxpCapability = {
  key: `data-services`,
  menuSections: [DXP_MENU_DATA_SERVICES_SECTION],
  path: getOrganisationPath(`/data-services`),
  prefix: `data-services`,
  title: DATA_SERVICES_CAPABILITY_STRINGS.title,
};

/**
 * Integrations.
 */
export const INTEGRATIONS: DxpCapability = {
  key: `integrations`,
  menuSections: [DXP_MENU_INTEGRATIONS_SECTION],
  path: getOrganisationPath(`/integrations`),
  prefix: `integrations`,
  title: INTEGRATIONS_CAPABILITY_STRINGS.title,
};

/**
 * Search.
 */
export const SEARCH: DxpCapability = {
  key: `search`,
  menuSections: [DXP_MENU_SEARCH_SECTION],
  path: getOrganisationPath(`/search`),
  prefix: `search`,
  title: SEARCH_CAPABILITY_STRINGS.title,
};
